// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__gy8v7","col":"CardReaderDesc_col__3fHwE","label":"CardReaderDesc_label__2t5WP"};